interface PlanBadgeProps {
  plan: string;
}

const PLAN_CONFIG: Record<string, { label: string; classes: string }> = {
  Starter: { label: 'Starter', classes: 'bg-slate-100 text-slate-700 ring-slate-600/20' },
  Professional: { label: 'Professional', classes: 'bg-primary/10 text-primary ring-primary/20' },
  Enterprise: { label: 'Enterprise', classes: 'bg-violet-50 text-violet-700 ring-violet-600/20' },
};

const FALLBACK_CONFIG = { classes: 'bg-sky-50 text-sky-700 ring-sky-600/20' };

export function PlanBadge({ plan }: PlanBadgeProps): JSX.Element {
  const config = PLAN_CONFIG[plan];
  const classes = config !== undefined ? config.classes : FALLBACK_CONFIG.classes;
  const label = config !== undefined ? config.label : plan;
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${classes}`}>
      {label}
    </span>
  );
}
